<template>
  <v-sheet
    width="100vw"
    height="100vh"
    class="d-flex justify-center align-center"
  >
    <v-card
      width="500"
      rounded
      class="pa-3"
    >
      <v-card-title>
        <h2>
          <c360-icon icon="Circle_Warning" :size="28" class="primary--text" />
          Ad Blocker Detected
        </h2>
      </v-card-title>
      <v-card-text>
        <p class="text-body-1">
          {{ warningText }}
        </p>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
  import Vue from 'vue';
  import { DEFAULT_WARNING } from '../model';
  import { C360Icon } from '../../../components/Icon';

  export default Vue.extend({
    name: 'AdBlockerWarning',

    components: {
      C360Icon,
    },

    props: {
      warningText: {
        type: String,
        default: DEFAULT_WARNING,
      }
    }
  });
</script>
